import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const ExpectedSaleEtcPrc = ({
  data,
}: {
  data?: IReportData['simulation3'];
}) => {
  return (
    <s.Div>
      <s.Title>💵 예상 매각 부대비용</s.Title>
      <s.Table>
        <s.TableHeader>
          <s.Header>항목</s.Header>
          <s.Header>금액</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>법무사비 (등기)</RowLeft>
          <RowRight>
            {data?.legalFee ? data?.legalFee.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>중개수수료</RowLeft>
          <RowRight>
            {data?.commission ? data?.commission.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row style={{ backgroundColor: '#F0F8FF' }}>
          <RowLeft>매각 부대비용 합계</RowLeft>
          <RowRight style={{ color: '#008AFF' }}>
            {data?.legalFee && data?.commission ? (data.legalFee + data.commission).toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
      </s.Table>
    </s.Div>
  );
};

export default ExpectedSaleEtcPrc;

const RowLeft = styled.div`
  width: 50%;
  height: 68px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 16px;
  font-size: 13px;
`;

const RowMiddle = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #616161;
`;

const RowRight = styled.div`
  width: 50%;
  padding: 16px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: end;
`;
